import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ErrorsHttpService } from '@qaroni-core/services/comms/errors-http/errors-http.service';
import { OAuthSnackbarsService } from './o-auth-snackbars.service';

@Injectable({
  providedIn: 'root',
})
export class OAuthErrorService {
  private errorsHttp = inject(ErrorsHttpService);
  private snackbars = inject(OAuthSnackbarsService);

  public errorLogin(error: HttpErrorResponse): void {
    if (
      this.errorsHttp.isErrorCode(error, 'E0002') ||
      this.errorsHttp.isErrorCode(error, 'E0004')
    ) {
      this.snackbars.failureLogin();
    }
  }
}
